/* eslint-disable import/no-extraneous-dependencies */
import React from "react";

import { Box } from "@mui/material";
import { ToastContainer, Slide } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import "../../../react-toastify-theme.css";

function Notify() {
  return (
    <Box component="span">
      <ToastContainer
        position="top-right"
        autoClose={4500}
        newestOnTop
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        draggableDirection="x"
        draggablePercent={50}
        pauseOnHover
        theme="colored"
        limit={5}
        transition={Slide}
        toastStyle={{ fontFamily: "inherit" }}
      />
    </Box>
  );
}

export default Notify;
